var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseiconnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-md-close-circle-outline",
    "data-name": "Icon ionic-md-close-circle-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M15.375,5.8A9.573,9.573,0,1,1,8.6,8.6a9.537,9.537,0,0,1,6.773-2.8m0-2.423a12,12,0,1,0,12,12,12,12,0,0,0-12-12Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M19.517,18.282l-1.235,1.235-3.18-3.18-3.18,3.18-1.235-1.235,3.18-3.18-3.18-3.18,1.235-1.235,3.18,3.18,3.18-3.18,1.235,1.235-3.18,3.18Z",
    transform: "translate(-3.102 -3.102)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseiconnew);
export default __webpack_public_path__ + "static/media/closeiconnew.d58c2ead2d69ebfce17fdd2a8077fbe6.svg";
export { ForwardRef as ReactComponent };